import { useEffect, useState } from "react";
import {
  CountyOption,
  getCountyList,
  getStateList,
} from "utils/api/lookupApi";

// USA = "840". When `stateAbbrs` is non-empty, resolve each StateAbbr to its
// numeric StateCode (via the cached state list) and pass the joined list as
// `stateCodeList` so the backend narrows counties to those states.
export function useCountyList(stateAbbrs?: string[]): CountyOption[] {
  const [options, setOptions] = useState<CountyOption[]>([]);
  // Sort + join so the effect dep doesn't churn on insertion-order changes.
  const stateAbbrsKey = (stateAbbrs ?? []).slice().sort().join(",");
  useEffect(() => {
    let mounted = true;
    (async () => {
      let stateCodeList: string | undefined;
      if (stateAbbrs && stateAbbrs.length > 0) {
        const states = await getStateList();
        const abbrToCode = new Map(states.map((s) => [s.value, s.stateCode]));
        const codes = stateAbbrs
          .map((a) => abbrToCode.get(a))
          .filter((c): c is string => !!c);
        stateCodeList = codes.length > 0 ? codes.join(",") : undefined;
      }
      const opts = await getCountyList("840", undefined, stateCodeList);
      if (mounted) setOptions(opts);
    })();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateAbbrsKey]);
  return options;
}
